import React from 'react';
import ParentLayout from '../Layout';
import useRouter from '../../../hooks/useRouter';
import Event from '../../events/Event';
import DateCreated from '../../events/_fields/DateCreated';
import MissingFields from '../../events/_fields/MissingFields';
import useQuery from './useQuery.last4weeks';
import CardChildrenWrapper from '../../_common_results/CardChildrenWrapper';

export default function Layout(props) {
  const { location } = useRouter();

  const PAGE_SIZE = 10;

  const result = useQuery({
    location,
    PAGE_SIZE
  });

  return (
    <ParentLayout
      breadcrumbs={['Explore', 'Events']}
      title="Incomplete Events"
      description={(
        <span>
          These are events that an educator started but did not complete the minimum information
          to be shown publicly on the platform. CommunityShare recommends a quick call or email
          to remind them that you are here to help them talk through their ideas and needs. Choosing
          the project from their home page will highlight exactly which fields are missing.
        </span>
      )}
      pageSize={PAGE_SIZE}
      result={result}
      row={function(event) {
        return (
          <Event key={event.id} event={event}>
            <CardChildrenWrapper>
              <div className="grid grid-cols-2 gap-4 w-full">
                <DateCreated event={event} />
                <MissingFields event={event} />
              </div>
            </CardChildrenWrapper>
          </Event>
        );
      }}
    />
  );
}
